import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: function (resolve) {
        require(['../wxOauth/Oauth.vue'], resolve)
      }
    },
   
    {
      path: '/homeTest',
      component: function (resolve) {
        require(['../components/Home.vue'], resolve)
      }
    },
    {
      path: '/home2',
      component: function (resolve) {
        require(['../components/Home2.vue'], resolve)
      }
    },
    {
      path: '/stockSearch',
      component: function (resolve) {
        require(['../components/StockSearch.vue'], resolve)
      }
    },
    {
      path: '/stockDetailTest',
      component: function (resolve) {
        require(['../components/StockDetail.vue'], resolve)
      }
    },
    {
      path: '/stockDetail2',
      component: function (resolve) {
        require(['../components/StockDetail2.vue'], resolve)
      }
    },
    {
      path: '/stockDetail3',
      component: function (resolve) {
        require(['../components/StockDetail3.vue'], resolve)
      }
    },
  
    {
      path: '/recommendedStock',
      component: function (resolve) {
        require(['../components/RecommendedStock.vue'], resolve)
      }
    },

    {
      path: '/taskExchange',
      component: function (resolve) {
        require(['../components/TaskExchange.vue'], resolve)
      }
    },

    {
      path: '/exchangeRecords',
      component: function (resolve) {
        require(['../components/ExchangeRecords.vue'], resolve)
      }
    },

    {
      path: '/userInfo',
      component: function (resolve) {
        require(['../components/UserInfo.vue'], resolve)
      }
    },

    {
      path: '/assistant',
      component: function (resolve) {
        require(['../components/Assistant.vue'], resolve)
      }
    },

    {
      path: '/receiveStep1',
      component: function (resolve) {
        require(['../components/ReceiveStep1.vue'], resolve)
      }
    },

    {
      path: '/receiveStep2',
      component: function (resolve) {
        require(['../components/ReceiveStep2.vue'], resolve)
      }
    },

    {
      path: '/receiveStep3',
      component: function (resolve) {
        require(['../components/ReceiveStep3.vue'], resolve)
      }
    },
    {
      path: '/userGroup',
      component: function (resolve) {
        require(['../components/UserGroup.vue'], resolve)
      }
    },

    {
      path: '/userInfo2',
      component: function (resolve) {
        require(['../components/UserInfo2.vue'], resolve)
      }
    },

    {
      path: '/memberPrivileges',
      component: function (resolve) {
        require(['../components/MemberPrivileges.vue'], resolve)
      }
    },

    {
      path: '/memberPrivileges2',
      component: function (resolve) {
        require(['../components/MemberPrivileges2.vue'], resolve)
      }
    },

    {
      path: '/openVip',
      component: function (resolve) {
        require(['../components/OpenVip.vue'], resolve)
      }
    },

    {
      path: '/openVip2',
      component: function (resolve) {
        require(['../components/OpenVip2.vue'], resolve)
      }
    },


    {
      path: '/purchaseRecords',
      component: function (resolve) {
        require(['../components/PurchaseRecords.vue'], resolve)
      }
    },

    {
      path: '/phoneBind',
      component: function (resolve) {
        require(['../components/PhoneBind.vue'], resolve)
      }
    },

    {
      path: '/selfStock',
      component: function (resolve) {
        require(['../components/SelfStock.vue'], resolve)
      }
    },

    {
      path: '/profit',
      component: function (resolve) {
        require(['../components/Profit.vue'], resolve)
      }
    },

    {
      path: '/allProfit',
      component: function (resolve) {
        require(['../components/AllProfit.vue'], resolve)
      }
    },

    {
      path: '/allStock',
      component: function (resolve) {
        require(['../components/AllStock.vue'], resolve)
      }
    },

    {
      path: '/useDiscountCode',
      component: function (resolve) {
        require(['../components/UseDiscountCode.vue'], resolve)
      }
    },

    {
      path: '/useDiscountCode2',
      component: function (resolve) {
        require(['../components/UseDiscountCode2.vue'], resolve)
      }
    },

    {
      path: '/group',
      component: function (resolve) {
        require(['../components/Group.vue'], resolve)
      }
    },

    {
      path: '/groupList',
      component: function(resolve) {
        require(['../components/GroupList.vue'], resolve)
      }
    }

  ],
  // mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js